import { call, put, select, takeLatest } from "redux-saga/effects";
import { Api } from "laravel-request";
import * as interfaceActions from "#app/store/actions/interface";
import { IndexedDBCache, ModelHelper } from "finhelper";
import moment from "moment";
import { getSingleUserAccount } from "#app/api/portfolio";

function* getApplications(action) {
    try {
        const promise = new Promise((resolve, reject) => {
            Api.get("crm-contact", "index")
                .with("requisite")
                .with("requisite_bank")
                .with("files")
                .all(
                    (response) => {
                        resolve(response);
                    },
                    () => {
                        reject();
                    }
                );
        });

        let response = yield promise;

        yield put(interfaceActions.handleContacts(response));

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        console.error(err);
    }
}

function* getContacts(action) {
    try {
        const promise = new Promise((resolve, reject) => {
            Api.get("crm-contact", "index")
                .with("requisite")
                .with("requisite_bank")
                .with("files")
                .all(
                    (response) => {
                        resolve(response);
                    },
                    () => {
                        reject();
                    }
                );
        });

        let response = yield promise;

        yield put(interfaceActions.handleContacts(response));

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        console.error(err);
    }
}

function* getContactById(action) {
    try {
        let contactId = action.payload.id;

        const promise = new Promise((resolve, reject) => {
            Api.get("crm-contact", "index")
                .where("id", contactId)
                .with("requisite")
                .with("requisite_bank")
                .with("files")
                .all(
                    (response) => {
                        resolve(response);
                    },
                    () => {
                        reject();
                    }
                );
        });

        let response = yield promise;

        yield put(interfaceActions.handleContactById({ id: contactId, data: response?.data }));

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        console.error(err);
    }
}

function* getClients(action) {
    try {
        const promise = new Promise((resolve, reject) => {
            Api.get("client", "index")
                .orderBy("id", "ASC")
                .all(
                    (response) => {
                        resolve(response);
                    },
                    (response) => {
                        reject();
                    }
                );
        });

        let response = yield promise;

        yield put(interfaceActions.handleClients(response));

        // let Client = localStorage.getItem('Client') ? JSON.parse(localStorage.getItem('Client')) : null;
        // if(Client)
        // {
        //   let id = Client.id;
        //
        //   if(id)
        //   {
        //     let Client = null;
        //     response.data.map((item) =>
        //     {
        //       if(item.id === id)
        //       {
        //         Client = item;
        //       }
        //     });
        //
        //     yield put(interfaceActions.handleCurrentClient(Client));
        //   }
        // }else{
        //   yield put(interfaceActions.handleCurrentClient((response.data[0] ? response.data[0] : null)));
        // }

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        console.error(err);
    }
}

function* getCurrencies(action) {
    try {
        const cachePromise = new Promise(async (resolve, reject) => {
            let data = await IndexedDBCache.get("currencies");

            resolve(data);
        });

        let data = yield cachePromise;

        if (!data) {
            const promise = new Promise((resolve, reject) => {
                Api.get("currency", "index")
                    .setDomain(process.env.REACT_APP_API_WHITESWAN_URL)
                    .with("cb_currency")
                    .orderBy("order")
                    .all(
                        (response) => {
                            resolve(response);
                        },
                        (response) => {
                            reject();
                        }
                    );
            });

            let response = yield promise;

            data = response.data;

            IndexedDBCache.set("currencies", data, 1000 * 60 * 60 * 24);
        }

        yield put(interfaceActions.handleCurrencies(data));

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        console.error(err);
    }
}

function* getUserAccounts(action) {
    try {
        const state = yield select();

        if (state.interfaceComponents.client) {
            const promise = new Promise((resolve, reject) => {
                getSingleUserAccount(state.interfaceComponents.client.id, resolve, reject);
            });

            let response = yield promise;
            yield put(interfaceActions.handleUserAccounts(response));
        } else {
            yield put(interfaceActions.handleUserAccounts({ data: [] }));
        }

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        console.error(err);
    }
}

function* getCourses(action) {
    try {
        let now = moment().format("YYYY-MM-DD");

        const cachePromise = new Promise(async (resolve, reject) => {
            let data = await IndexedDBCache.get("courses_" + now);

            resolve(data);
        });

        let data = yield cachePromise;

        if (!data) {
            const promise = new Promise((resolve, reject) => {
                Api.get("cb-history-currency-course", "latest")
                    .setDomain(process.env.REACT_APP_API_WHITESWAN_URL)
                    .all(
                        (response) => {
                            resolve(response);
                        },
                        (xhr) => {
                            reject();
                        }
                    );
            });

            let response = yield promise;

            data = response.data;

            IndexedDBCache.set("courses_" + now, data, 1000 * 60 * 60 * 24);
        }

        yield put(interfaceActions.handleCourses(data));

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        console.error(err);
    }
}

function* getSpendTypes(action) {
    try {
        const state = yield select();

        if (state.interfaceComponents.client) {
            const promise = new Promise((resolve, reject) => {
                Api.get("active", "spending-types", {
                    user_id: state.interfaceComponents.client.id,
                    all: true,
                }).call(
                    (response) => {
                        resolve(response);
                    },
                    () => {
                        reject();
                    }
                );
            });

            let response = yield promise;

            yield put(interfaceActions.handleSpendTypes(response));

            if (action.payload && typeof action.payload.callback === "function") {
                yield call(action.payload.callback);
            }
        }
    } catch (err) {
        console.error(err);
    }
}

function* getIncomeTypes(action) {
    try {
        const state = yield select();

        if (state.interfaceComponents.client) {
            const promise = new Promise((resolve, reject) => {
                Api.get("active", "income-types", {
                    user_id: state.interfaceComponents.client.id,
                    all: true,
                }).call(
                    (response) => {
                        resolve(response);
                    },
                    () => {
                        reject();
                    }
                );
            });

            let response = yield promise;

            yield put(interfaceActions.handleIncomeTypes(response));

            if (action.payload && typeof action.payload.callback === "function") {
                yield call(action.payload.callback);
            }
        }
    } catch (err) {
        console.error(err);
    }
}

function* getActiveTags(action) {
    try {
        const state = yield select();

        if (state.interfaceComponents.client) {
            const promise = new Promise((resolve, reject) => {
                Api.get("active-tag", "index", {
                    user_id: state.interfaceComponents.client.id,
                }).all(
                    (response) => {
                        resolve(response);
                    },
                    () => {
                        reject();
                    }
                );
            });

            let response = yield promise;

            yield put(interfaceActions.handleActiveTags(response));

            if (action.payload && typeof action.payload.callback === "function") {
                yield call(action.payload.callback);
            }
        }
    } catch (err) {
        console.error(err);
    }
}

function* getActiveSubcategories(action) {
    try {
        const state = yield select();

        if (state.interfaceComponents.client) {
            const promise = new Promise((resolve, reject) => {
                Api.get("active-subcategory", "index", {
                    user_id: state.interfaceComponents.client.id,
                }).all(
                    (response) => {
                        resolve(response);
                    },
                    () => {
                        reject();
                    }
                );
            });

            let response = yield promise;

            yield put(interfaceActions.handleActiveSubcategories(response));

            if (action.payload && typeof action.payload.callback === "function") {
                yield call(action.payload.callback);
            }
        }
    } catch (err) {
        console.error(err);
    }
}

function* getPropertyTypes(action) {
    try {
        const state = yield select();

        if (state.interfaceComponents.client) {
            const promise = new Promise((resolve, reject) => {
                Api.get("active", "property-types", {
                    user_id: state.interfaceComponents.client.id,
                }).all(
                    (response) => {
                        resolve(response);
                    },
                    () => {
                        reject();
                    }
                );
            });

            let response = yield promise;

            yield put(interfaceActions.handlePropertyTypes(response));

            if (action.payload && typeof action.payload.callback === "function") {
                yield call(action.payload.callback);
            }
        }
    } catch (err) {
        console.error(err);
    }
}

function* getInvestTypes(action) {
    try {
        const state = yield select();

        if (state.interfaceComponents.client) {
            const promise = new Promise((resolve, reject) => {
                Api.get("active", "invest-types", {
                    user_id: state.interfaceComponents.client.id,
                }).all(
                    (response) => {
                        resolve(response);
                    },
                    () => {
                        reject();
                    }
                );
            });

            let response = yield promise;

            yield put(interfaceActions.handleInvestTypes(response));

            if (action.payload && typeof action.payload.callback === "function") {
                yield call(action.payload.callback);
            }
        }
    } catch (err) {
        console.error(err);
    }
}

function* getGroupTypes(action) {
    try {
        const state = yield select();

        if (state.interfaceComponents.client) {
            const promise = new Promise((resolve, reject) => {
                Api.get("active", "group-types", {
                    user_id: state.interfaceComponents.client.id,
                }).all(
                    (response) => {
                        resolve(response);
                    },
                    () => {
                        reject();
                    }
                );
            });

            let response = yield promise;

            yield put(interfaceActions.handleGroupTypes(response));

            if (action.payload && typeof action.payload.callback === "function") {
                yield call(action.payload.callback);
            }
        }
    } catch (err) {
        console.error(err);
    }
}

function* getClassTypes(action) {
    try {
        const state = yield select();

        if (state.interfaceComponents.client) {
            const promise = new Promise((resolve, reject) => {
                Api.get("active", "class-types", {
                    user_id: state.interfaceComponents.client.id,
                }).all(
                    (response) => {
                        resolve(response);
                    },
                    () => {
                        reject();
                    }
                );
            });

            let response = yield promise;

            yield put(interfaceActions.handleClassTypes(response));

            if (action.payload && typeof action.payload.callback === "function") {
                yield call(action.payload.callback);
            }
        }
    } catch (err) {
        console.error(err);
    }
}

function* postCustomGroupType(action) {
    try {
        const promise = new Promise((resolve, reject) => {
            Api.post("active-custom-group-type", "store", action.payload.form)
                .withoutNotify()
                .call(
                    (response) => {
                        action.payload.success(response);

                        resolve(response);
                    },
                    (xhr, responseData) => {
                        action.payload.error(xhr, responseData);

                        reject();
                    }
                );
        });

        let response = yield promise;

        yield put(interfaceActions.getGroupTypes());

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        console.error(err);
    }
}

function* postCustomClassType(action) {
    try {
        const promise = new Promise((resolve, reject) => {
            Api.post("active-custom-class-type", "store", action.payload.form)
                .withoutNotify()
                .call(
                    (response) => {
                        action.payload.success(response);

                        resolve(response);
                    },
                    (xhr, responseData) => {
                        action.payload.error(xhr, responseData);

                        reject();
                    }
                );
        });

        let response = yield promise;

        yield put(interfaceActions.getClassTypes());

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        console.error(err);
    }
}

function* postCustomType(action) {
    try {
        const promise = new Promise((resolve, reject) => {
            Api.post("active-custom-type", "store", action.payload.form)
                .withoutNotify()
                .call(
                    (response) => {
                        action.payload.success(response);

                        resolve(response);
                    },
                    (xhr, responseData) => {
                        action.payload.error(xhr, responseData);

                        reject();
                    }
                );
        });

        let response = yield promise;

        yield put(interfaceActions.getSpendTypes());
        yield put(interfaceActions.getIncomeTypes());
        yield put(interfaceActions.getActiveTags());
        yield put(interfaceActions.getActiveSubcategories());
        yield put(interfaceActions.getPropertyTypes());
        yield put(interfaceActions.getInvestTypes());

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        console.error(err);
    }
}

function* putCustomType(action) {
    try {
        const promise = new Promise((resolve, reject) => {
            Api.putArg("active-custom-type", "update", action.payload.form.id, action.payload.form)
                .withoutNotify()
                .call(
                    (response) => {
                        action.payload.success(response);

                        resolve(response);
                    },
                    (xhr, responseData) => {
                        action.payload.error(xhr, responseData);

                        reject();
                    }
                );
        });

        let response = yield promise;

        yield put(interfaceActions.getSpendTypes());
        yield put(interfaceActions.getIncomeTypes());
        yield put(interfaceActions.getActiveTags());
        yield put(interfaceActions.getActiveSubcategories());
        yield put(interfaceActions.getPropertyTypes());
        yield put(interfaceActions.getInvestTypes());

        if (action.payload && typeof action.payload.callback === "function") {
            yield call(action.payload.callback);
        }
    } catch (err) {
        console.error(err);
    }
}

export default function* watcher() {
    yield takeLatest(interfaceActions.getCurrencies, getCurrencies);
    yield takeLatest(interfaceActions.getClients, getClients);
    yield takeLatest(interfaceActions.getUserAccounts, getUserAccounts);
    yield takeLatest(interfaceActions.getCourses, getCourses);
    yield takeLatest(interfaceActions.getSpendTypes, getSpendTypes);
    yield takeLatest(interfaceActions.getIncomeTypes, getIncomeTypes);
    yield takeLatest(interfaceActions.getActiveTags, getActiveTags);
    yield takeLatest(interfaceActions.getActiveSubcategories, getActiveSubcategories);
    yield takeLatest(interfaceActions.getPropertyTypes, getPropertyTypes);
    yield takeLatest(interfaceActions.getInvestTypes, getInvestTypes);
    yield takeLatest(interfaceActions.getGroupTypes, getGroupTypes);
    yield takeLatest(interfaceActions.getClassTypes, getClassTypes);
    yield takeLatest(interfaceActions.postCustomType, postCustomType);
    yield takeLatest(interfaceActions.putCustomType, putCustomType);
    yield takeLatest(interfaceActions.postCustomGroupType, postCustomGroupType);
    yield takeLatest(interfaceActions.postCustomClassType, postCustomClassType);
    yield takeLatest(interfaceActions.getContacts, getContacts);
    yield takeLatest(interfaceActions.getContactById, getContactById);
}
